"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propOptionsGenerator = void 0;

var validators_1 = require("./validators");

var propOptionsGenerator = function propOptionsGenerator(type, userValidator) {
  for (var _len = arguments.length, typeValidators = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    typeValidators[_key - 2] = arguments[_key];
  }

  return {
    optional: {
      type: type,
      required: false,
      default: undefined,
      validator: (0, validators_1.vuePropValidator).apply(void 0, [userValidator].concat(typeValidators))
    },
    nullable: {
      type: type,
      required: false,
      default: null,
      validator: (0, validators_1.vuePropValidator).apply(void 0, [userValidator].concat(typeValidators))
    },
    withDefault: function withDefault(defaultValue) {
      return {
        type: type,
        required: false,
        default: defaultValue,
        validator: (0, validators_1.vuePropValidator).apply(void 0, [userValidator].concat(typeValidators))
      };
    },
    required: {
      type: type,
      required: true,
      validator: (0, validators_1.vuePropValidator).apply(void 0, [userValidator].concat(typeValidators))
    }
  };
};

exports.propOptionsGenerator = propOptionsGenerator;